export enum AccessibilityHtmlTags {
    MainHeading = 'h1',
    SecondaryHeading = 'h2',
    Paragraph = 'p',
}
